// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../dist/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../dist/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_container__8JxuT {
  position: relative;
}

.styles_text__IsgOA {
  font-weight: 500;
  font-size: 10px;
  line-height: 20px;
  /* or 143% */
  display: flex;
  align-items: center;
  text-align: center;
  /* Gray 3 */
  color: #828282;
}

.styles_absoluteBox__enimz {
  display: flex;
  position: absolute;
  display: flex;
  width: 356px;
  height: auto;
  top: 100%;
  left: 0;
  z-index: 900;
  box-shadow: 0px 9px 28px 8px rgba(0, 0, 0, 0.05), 0px 6px 16px rgba(0, 0, 0, 0.08), 0px 3px 6px -4px rgba(0, 0, 0, 0.12);
  border-radius: 2px;
  padding: 15px 11px;
}

.styles_absoluteBox__enimz p {
  margin-bottom: 13px;
}

@media only screen and (max-width: 800px) {
  .styles_absoluteBox__enimz {
    width: 80vw;
  }
}`, "",{"version":3,"sources":["webpack://./../src/renderer/components/HelpBox/styles.module.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;AACF;;AAEA;EACE,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,YAAA;EAEA,aAAA;EACA,mBAAA;EACA,kBAAA;EAEA,WAAA;EAEA,cAAA;AAFF;;AAKA;EACE,aAAA;EACA,kBAAA;EACA,aAAA;EACA,YAAA;EACA,YAAA;EACA,SAAA;EACA,OAAA;EACA,YAAA;EAEA,wHAAA;EACA,kBAAA;EACA,kBAAA;AAHF;;AAMA;EACE,mBAAA;AAHF;;AAOA;EAEE;IACE,WAAA;EALF;AACF","sourcesContent":[".container {\n  position: relative;\n}\n\n.text {\n  font-weight: 500;\n  font-size: 10px;\n  line-height: 20px;\n  /* or 143% */\n\n  display: flex;\n  align-items: center;\n  text-align: center;\n\n  /* Gray 3 */\n\n  color: #828282;\n}\n\n.absoluteBox {\n  display: flex;\n  position: absolute;\n  display: flex;\n  width: 356px;\n  height: auto;\n  top: 100%;\n  left: 0;\n  z-index: 900;\n  // background: #FFFFFF;\n  box-shadow: 0px 9px 28px 8px rgba(0, 0, 0, 0.05), 0px 6px 16px rgba(0, 0, 0, 0.08), 0px 3px 6px -4px rgba(0, 0, 0, 0.12);\n  border-radius: 2px;\n  padding: 15px 11px;\n}\n\n.absoluteBox p {\n  margin-bottom: 13px;\n}\n\n// @media only screen and (max-width: 576px) {\n@media only screen and (max-width: 800px) {\n\n  .absoluteBox {\n    width: 80vw;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `styles_container__8JxuT`,
	"text": `styles_text__IsgOA`,
	"absoluteBox": `styles_absoluteBox__enimz`
};
export default ___CSS_LOADER_EXPORT___;
